import { z } from "zod";

let configured = false;

/**
 * Installs a global Zod error map that augments `invalid_value` failures
 * (`z.enum` / `z.literal`) with the received value, e.g.
 * `Invalid option: expected one of "a" | "b", received "c"`.
 *
 * Zod's global config is a per-process singleton read at parse time, so this
 * MUST be called once at the top of every process entrypoint that parses
 * (backend `index.ts`, frontend `index.tsx`, workers, test setup) — before the
 * first `.parse`/oRPC validation runs. Calling it again is a no-op.
 */
export function configureZodInvalidValueErrors(): void {
  if (configured) return;
  configured = true;

  z.config({
    customError: (issue) => {
      if (issue.code === "invalid_value") {
        const expected = issue.values
          .map((value) => JSON.stringify(value))
          .join(" | ");
        return `Invalid option: expected one of ${expected}, received ${JSON.stringify(issue.input)}`;
      }
      // Returning undefined falls through to the default locale message, so
      // every other issue type keeps its standard wording.
      return undefined;
    },
  });
}
